import { TrackSegmentKind, VehicleTrackSegment } from '../../../types/fallbackTrackingTypes';
import { PolylineProps } from '../../../types/MapModels';

interface SegmentStyle {
    label: string;
    description: string;
    strokeColor: string;
    strokeThickness: number;
}

/** Presentation of each track segment kind: green real tracking, red synthetic tracking, grey interval without data. */
export const SEGMENT_STYLES: Record<TrackSegmentKind, SegmentStyle> = {
    Real: {
        label: 'Real tracking',
        description: 'Positions reported by the vehicle.',
        strokeColor: '#2e7d32',
        strokeThickness: 4,
    },
    Synthetic: {
        label: 'Synthetic tracking',
        description: 'Positions estimated by the GTFS-RT fallback from the schedule, keeping the observed delay.',
        strokeColor: '#d32f2f',
        strokeThickness: 6,
    },
    NoData: {
        label: 'No data',
        description: 'Retention window expired before the vehicle reported again; no predictions were published.',
        strokeColor: '#9e9e9e',
        strokeThickness: 2,
    },
};

/** Planned trip path drawn under the track segments. */
export const SHAPE_STYLE = {
    strokeColor: '#cfd8dc',
    strokeThickness: 3,
};

export function toSegmentPolyline(segment: VehicleTrackSegment): PolylineProps {
    const { strokeColor, strokeThickness } = SEGMENT_STYLES[segment.kind];
    return {
        locations: segment.points.map(({ latitude, longitude }) => [latitude, longitude]),
        options: { strokeColor, strokeThickness },
        metadata: { kind: segment.kind },
    };
}
